export default "/images/vendor/@coreui/icons/svg/flag/cif-ga.svg?c6ac170bf4215f5453e63d34804d6b8b";